export function swiperHover() {
  document.addEventListener("DOMContentLoaded", function () {
    var slides = document.querySelectorAll(".subpage-carousel .swiper-slide");

    slides.forEach(function (slide) {
      slide.addEventListener("mouseenter", function () {
        if (!slide.classList.contains("swiper-slide-active")) {
          var activeSlide = document.querySelector(
            ".subpage-carousel .swiper-slide-active"
          );
          if (activeSlide) {
            activeSlide.classList.add("inactive");
          }
        }
      });
      slide.addEventListener("mouseleave", function () {
        var activeSlide = document.querySelector(
          ".subpage-carousel .swiper-slide-active"
        );
        if (activeSlide) {
          activeSlide.classList.remove("inactive");
        }
      });
    });
  });
}
